const termsAndConditionsBlocksId = [
  {
    "type": "heading",
    "text": "Syarat & Ketentuan"
  },
  {
    "type": "paragraph",
    "text": "Diperbarui pada 2026-03-02"
  },
  {
    "type": "heading",
    "text": "Ketentuan Umum"
  },
  {
    "type": "paragraph",
    "text": "Dengan mengakses dan melakukan pemesanan pada Saat Teduh, Anda menegaskan bahwa Anda menyetujui dan terikat oleh syarat layanan yang tercantum dalam Syarat & Ketentuan di bawah ini. Ketentuan ini berlaku untuk seluruh website serta setiap email atau bentuk komunikasi lain antara Anda dan Saat Teduh."
  },
  {
    "type": "paragraph",
    "text": "Dalam keadaan apa pun tim Saat Teduh tidak bertanggung jawab atas kerugian langsung, tidak langsung, khusus, insidental, atau konsekuensial, termasuk namun tidak terbatas pada kehilangan data atau keuntungan, yang timbul dari penggunaan, atau ketidakmampuan menggunakan, materi pada situs ini, bahkan jika tim Saat Teduh atau perwakilan resmi telah diberitahu tentang kemungkinan kerugian tersebut. Jika penggunaan materi dari situs ini mengakibatkan perlunya servis, perbaikan, atau koreksi peralatan maupun data, Anda menanggung seluruh biayanya."
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh tidak bertanggung jawab atas hasil apa pun yang dapat terjadi selama penggunaan sumber daya kami. Kami berhak mengubah harga dan merevisi kebijakan penggunaan sumber daya kapan saja. Syarat & Ketentuan ini dibuat dengan Termify ."
  },
  {
    "type": "heading",
    "text": "Lisensi"
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh memberikan kepada Anda lisensi terbatas yang dapat dicabut, non-eksklusif, tidak dapat dipindahtangankan, untuk mengunduh, memasang, dan menggunakan aplikasi secara ketat sesuai dengan ketentuan Perjanjian ini."
  },
  {
    "type": "paragraph",
    "text": "Syarat & Ketentuan ini adalah kontrak antara Anda dan Saat Teduh (disebut dalam Syarat & Ketentuan ini sebagai \"Saat Teduh\", \"kami\", atau \"milik kami\"), penyedia website Saat Teduh dan layanan yang dapat diakses dari website Saat Teduh (yang secara kolektif disebut dalam Syarat & Ketentuan ini sebagai \"Layanan Saat Teduh\")."
  },
  {
    "type": "paragraph",
    "text": "Anda setuju untuk terikat oleh Syarat & Ketentuan ini. Jika Anda tidak setuju dengan Syarat & Ketentuan ini, mohon jangan gunakan Layanan Saat Teduh. Dalam Syarat & Ketentuan ini, \"Anda\" merujuk baik kepada Anda sebagai individu maupun kepada entitas yang Anda wakili. Jika Anda melanggar salah satu Syarat & Ketentuan ini, kami berhak membatalkan akun Anda atau memblokir akses ke akun Anda tanpa pemberitahuan."
  },
  {
    "type": "heading",
    "text": "Definisi dan istilah kunci"
  },
  {
    "type": "paragraph",
    "text": "Untuk membantu menjelaskan hal-hal sejelas mungkin dalam Syarat & Ketentuan ini, setiap kali istilah berikut dirujuk, istilah tersebut didefinisikan secara ketat sebagai:"
  },
  {
    "type": "list",
    "items": [
      "Cookie: sejumlah kecil data yang dihasilkan website dan disimpan oleh browser web Anda. Digunakan untuk mengidentifikasi browser Anda, menyediakan analitik, serta mengingat informasi tentang Anda seperti preferensi bahasa atau informasi login.",
      "Company: ketika kebijakan ini menyebut \"Company\", \"kami\", atau \"milik kami\", yang dimaksud adalah Saat Teduh, yang bertanggung jawab atas informasi Anda berdasarkan Syarat & Ketentuan ini.",
      "Country: tempat Saat Teduh atau pemilik/pendiri Saat Teduh berbasis, dalam hal ini adalah",
      "Device: perangkat apa pun yang terhubung internet seperti ponsel, tablet, komputer, atau perangkat lain yang dapat digunakan untuk mengunjungi Saat Teduh dan menggunakan layanan.",
      "Service: merujuk pada layanan yang disediakan oleh Saat Teduh sebagaimana dijelaskan dalam ketentuan terkait (jika tersedia) dan pada platform ini.",
      "Third-party service: merujuk pada pengiklan, sponsor kontes, mitra promosi dan pemasaran, serta pihak lain yang menyediakan konten kami atau produk/jasa yang kami anggap mungkin menarik bagi Anda.",
      "Website: situs milik Saat Teduh, yang dapat diakses melalui URL ini:",
      "You: orang atau entitas yang terdaftar di Saat Teduh untuk menggunakan Layanan."
    ]
  },
  {
    "type": "heading",
    "text": "Pembatasan"
  },
  {
    "type": "paragraph",
    "text": "Anda setuju untuk tidak, dan tidak akan mengizinkan pihak lain untuk:"
  },
  {
    "type": "list",
    "items": [
      "Memberi lisensi, menjual, menyewakan, mengalihkan, mendistribusikan, mentransmisikan, meng-host, melakukan outsourcing, mengungkapkan, atau mengeksploitasi aplikasi secara komersial maupun membuat platform tersedia bagi pihak ketiga mana pun.",
      "Memodifikasi, membuat karya turunan dari, membongkar, mendekripsi, reverse compile, atau reverse engineer bagian mana pun dari aplikasi.",
      "Menghapus, mengubah, atau menyamarkan pemberitahuan hak milik apa pun (termasuk pemberitahuan hak cipta atau merek dagang) milik Saat Teduh atau afiliasi, mitra, pemasok, atau pemberi lisensi aplikasi."
    ]
  },
  {
    "type": "heading",
    "text": "Kebijakan Pengembalian dan Refund"
  },
  {
    "type": "paragraph",
    "text": "Terima kasih telah berbelanja di Saat Teduh. Kami menghargai bahwa Anda menyukai produk yang kami buat. Kami juga ingin memastikan Anda mendapatkan pengalaman yang memuaskan saat menjelajah, mengevaluasi, dan membeli produk kami."
  },
  {
    "type": "paragraph",
    "text": "Seperti pengalaman berbelanja lainnya, ada syarat dan ketentuan yang berlaku untuk transaksi di Saat Teduh. Kami akan sesingkat mungkin sesuai yang diizinkan penasihat hukum kami. Hal utama yang perlu diingat adalah dengan melakukan pemesanan atau pembelian di Saat Teduh, Anda menyetujui ketentuan ini bersama Kebijakan Privasi Saat Teduh."
  },
  {
    "type": "paragraph",
    "text": "Jika karena alasan apa pun Anda tidak sepenuhnya puas dengan barang atau layanan apa pun yang kami berikan, jangan ragu untuk menghubungi kami dan kami akan membahas masalah apa pun yang Anda alami terkait produk kami."
  },
  {
    "type": "heading",
    "text": "Langganan Berulang Otomatis"
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh menawarkan langganan berulang otomatis. Langganan akan diperpanjang otomatis kecuali dibatalkan minimal 24 jam sebelum periode berjalan berakhir. Anda dapat mengelola atau membatalkan langganan di pengaturan akun Apple ID Anda."
  },
  {
    "type": "list",
    "items": [
      "Teduh Premium Bulanan: Rp 39.000 / bulan",
      "Teduh Premium Tahunan: Rp 399.000 / tahun",
      "Teduh Ultimate Bulanan: Rp 89.000 / bulan",
      "Teduh Ultimate Tahunan: Rp 899.000 / tahun",
      "Teduh Unlimited Bulanan: Rp 299.000 / bulan",
      "Teduh Unlimited Tahunan: Rp 2.999.000 / tahun"
    ]
  },
  {
    "type": "paragraph",
    "text": "Harga dapat berbeda menurut wilayah dan sudah termasuk pajak jika berlaku."
  },
  {
    "type": "heading",
    "text": "Saran Anda"
  },
  {
    "type": "paragraph",
    "text": "Setiap umpan balik, komentar, ide, peningkatan, atau saran (secara kolektif, \"Saran\") yang Anda berikan kepada Saat Teduh terkait aplikasi akan tetap menjadi milik tunggal dan eksklusif Saat Teduh."
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh bebas menggunakan, menyalin, memodifikasi, mempublikasikan, atau mendistribusikan ulang Saran tersebut untuk tujuan apa pun dan dengan cara apa pun tanpa kredit atau kompensasi apa pun kepada Anda."
  },
  {
    "type": "heading",
    "text": "Persetujuan Anda"
  },
  {
    "type": "paragraph",
    "text": "Kami telah memperbarui Syarat & Ketentuan kami untuk memberikan transparansi penuh kepada Anda tentang apa yang ditetapkan saat Anda mengunjungi situs kami dan bagaimana hal itu digunakan. Dengan menggunakan aplikasi kami, mendaftarkan akun, atau melakukan pembelian, Anda dengan ini menyetujui Syarat & Ketentuan kami."
  },
  {
    "type": "heading",
    "text": "Tautan ke Website Lain"
  },
  {
    "type": "paragraph",
    "text": "Syarat & Ketentuan ini hanya berlaku untuk Layanan. Layanan dapat berisi tautan ke website lain yang tidak dioperasikan atau dikendalikan oleh Saat Teduh. Kami tidak bertanggung jawab atas konten, akurasi, atau pendapat yang dinyatakan pada website tersebut, dan website tersebut tidak diselidiki, dipantau, atau diperiksa akurasi maupun kelengkapannya oleh kami. Harap diingat bahwa ketika Anda menggunakan tautan untuk berpindah dari Layanan ke website lain, Syarat & Ketentuan kami tidak lagi berlaku. Aktivitas penelusuran dan interaksi Anda pada website lain mana pun, termasuk yang memiliki tautan di platform kami, tunduk pada aturan dan kebijakan website tersebut. Pihak ketiga tersebut dapat menggunakan cookie mereka sendiri atau metode lain untuk mengumpulkan informasi tentang Anda."
  },
  {
    "type": "heading",
    "text": "Cookie"
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh menggunakan \"Cookies\" untuk mengidentifikasi area website kami yang Anda kunjungi. Cookie adalah data kecil yang disimpan pada komputer atau perangkat seluler Anda oleh browser web. Kami menggunakan Cookies untuk meningkatkan performa dan fungsionalitas aplikasi kami tetapi tidak esensial bagi penggunaannya. Namun, tanpa cookies ini, fungsi tertentu seperti video mungkin tidak tersedia atau Anda mungkin harus memasukkan detail login setiap kali mengunjungi aplikasi karena kami tidak dapat mengingat bahwa Anda telah login sebelumnya. Sebagian besar browser web dapat diatur untuk menonaktifkan penggunaan Cookies. Namun, jika Anda menonaktifkan Cookies, Anda mungkin tidak dapat mengakses fungsi pada website kami dengan benar atau sama sekali. Kami tidak pernah menempatkan Informasi Identitas Pribadi dalam Cookies."
  },
  {
    "type": "heading",
    "text": "Perubahan pada Syarat & Ketentuan Kami"
  },
  {
    "type": "paragraph",
    "text": "Anda mengakui dan menyetujui bahwa Saat Teduh dapat menghentikan (secara permanen atau sementara) penyediaan Layanan (atau fitur apa pun dalam Layanan) kepada Anda atau kepada pengguna secara umum atas kebijakannya sendiri, tanpa pemberitahuan sebelumnya kepada Anda. Anda dapat berhenti menggunakan Layanan kapan saja. Anda tidak perlu secara khusus memberi tahu Saat Teduh ketika Anda berhenti menggunakan Layanan. Anda mengakui dan menyetujui bahwa jika Saat Teduh menonaktifkan akses ke akun Anda, Anda dapat dicegah mengakses Layanan, detail akun Anda, atau file maupun materi lain apa pun yang terdapat dalam akun Anda."
  },
  {
    "type": "paragraph",
    "text": "Jika kami memutuskan untuk mengubah Syarat & Ketentuan kami, kami akan memposting perubahan tersebut pada halaman ini, dan/atau memperbarui tanggal perubahan Syarat & Ketentuan di bawah ini."
  },
  {
    "type": "heading",
    "text": "Perubahan pada aplikasi Kami"
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh berhak memodifikasi, menangguhkan, atau menghentikan, secara sementara maupun permanen, aplikasi atau layanan apa pun yang terhubung dengannya, dengan atau tanpa pemberitahuan serta tanpa tanggung jawab kepada Anda."
  },
  {
    "type": "heading",
    "text": "Pembaruan pada aplikasi Kami"
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh dari waktu ke waktu dapat menyediakan peningkatan atau perbaikan pada fitur/fungsionalitas aplikasi, yang dapat mencakup patch, perbaikan bug, pembaruan, upgrade, dan modifikasi lainnya (\"Pembaruan\")."
  },
  {
    "type": "paragraph",
    "text": "Pembaruan dapat memodifikasi atau menghapus fitur dan/atau fungsionalitas tertentu dari aplikasi. Anda setuju bahwa Saat Teduh tidak berkewajiban untuk (i) menyediakan Pembaruan apa pun, atau (ii) terus menyediakan atau mengaktifkan fitur dan/atau fungsionalitas tertentu dari aplikasi kepada Anda."
  },
  {
    "type": "paragraph",
    "text": "Anda selanjutnya setuju bahwa semua Pembaruan akan (i) dianggap sebagai bagian integral dari aplikasi, dan (ii) tunduk pada syarat dan ketentuan Perjanjian ini."
  },
  {
    "type": "heading",
    "text": "Layanan Pihak Ketiga"
  },
  {
    "type": "paragraph",
    "text": "Kami dapat menampilkan, menyertakan, atau menyediakan konten pihak ketiga (termasuk data, informasi, aplikasi, dan produk layanan lainnya) atau menyediakan tautan ke website atau layanan pihak ketiga (\"Layanan Pihak Ketiga\")."
  },
  {
    "type": "paragraph",
    "text": "Anda mengakui dan menyetujui bahwa Saat Teduh tidak bertanggung jawab atas Layanan Pihak Ketiga mana pun, termasuk akurasi, kelengkapan, ketepatan waktu, validitas, kepatuhan hak cipta, legalitas, kesopanan, kualitas, atau aspek lainnya. Saat Teduh tidak memikul dan tidak akan memiliki tanggung jawab apa pun kepada Anda atau orang maupun entitas lain atas Layanan Pihak Ketiga mana pun."
  },
  {
    "type": "paragraph",
    "text": "Layanan Pihak Ketiga dan tautannya disediakan semata-mata sebagai kemudahan bagi Anda dan Anda mengakses serta menggunakannya sepenuhnya atas risiko Anda sendiri dan tunduk pada syarat serta ketentuan pihak ketiga tersebut."
  },
  {
    "type": "heading",
    "text": "Masa Berlaku dan Pengakhiran"
  },
  {
    "type": "paragraph",
    "text": "Perjanjian ini akan tetap berlaku hingga diakhiri oleh Anda atau Saat Teduh."
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh dapat, atas kebijakannya sendiri, kapan saja dan dengan atau tanpa alasan apa pun, menangguhkan atau mengakhiri Perjanjian ini dengan atau tanpa pemberitahuan sebelumnya."
  },
  {
    "type": "paragraph",
    "text": "Perjanjian ini akan berakhir segera, tanpa pemberitahuan sebelumnya dari Saat Teduh, apabila Anda gagal mematuhi ketentuan mana pun dalam Perjanjian ini. Anda juga dapat mengakhiri Perjanjian ini dengan menghapus aplikasi dan semua salinannya dari komputer Anda."
  },
  {
    "type": "paragraph",
    "text": "Setelah pengakhiran Perjanjian ini, Anda harus menghentikan seluruh penggunaan aplikasi dan menghapus semua salinan aplikasi dari komputer Anda."
  },
  {
    "type": "paragraph",
    "text": "Pengakhiran Perjanjian ini tidak akan membatasi hak atau upaya hukum Saat Teduh, baik menurut hukum maupun keadilan, dalam hal pelanggaran oleh Anda (selama masa berlaku Perjanjian ini) atas kewajiban Anda berdasarkan Perjanjian ini."
  },
  {
    "type": "heading",
    "text": "Pemberitahuan Pelanggaran Hak Cipta"
  },
  {
    "type": "paragraph",
    "text": "Jika Anda adalah pemilik hak cipta atau agen pemilik tersebut dan meyakini bahwa materi apa pun pada aplikasi kami merupakan pelanggaran hak cipta Anda, silakan hubungi kami dengan menyampaikan informasi berikut: (a) tanda tangan fisik atau elektronik dari pemilik hak cipta atau orang yang berwenang bertindak atas namanya; (b) identifikasi materi yang diklaim melanggar; (c) informasi kontak Anda, termasuk alamat, nomor telepon, dan email; (d) pernyataan dari Anda bahwa Anda memiliki keyakinan dengan itikad baik bahwa penggunaan materi tersebut tidak diizinkan oleh pemilik hak cipta; dan (e) pernyataan bahwa informasi dalam pemberitahuan tersebut akurat, serta, di bawah ancaman pidana sumpah palsu, Anda berwenang bertindak atas nama pemilik."
  },
  {
    "type": "heading",
    "text": "Ganti Rugi"
  },
  {
    "type": "paragraph",
    "text": "Anda setuju untuk mengganti rugi dan membebaskan Saat Teduh beserta induk, anak perusahaan, afiliasi, pejabat, karyawan, agen, mitra, dan pemberi lisensinya (jika ada) dari setiap klaim atau tuntutan, termasuk biaya pengacara yang wajar, yang timbul karena atau terkait dengan: (a) penggunaan aplikasi oleh Anda; (b) pelanggaran Perjanjian ini atau hukum/peraturan apa pun; atau (c) pelanggaran hak pihak ketiga mana pun."
  },
  {
    "type": "heading",
    "text": "Tanpa Jaminan"
  },
  {
    "type": "paragraph",
    "text": "Aplikasi disediakan kepada Anda \"AS IS\" dan \"AS AVAILABLE\" serta dengan seluruh cacat dan kekurangan tanpa jaminan apa pun. Sejauh diizinkan oleh hukum yang berlaku, Saat Teduh, atas namanya sendiri dan atas nama afiliasi serta pemberi lisensi dan penyedia layanan masing-masing, secara tegas menolak semua jaminan, baik tersurat, tersirat, berdasarkan undang-undang, maupun lainnya, sehubungan dengan aplikasi, termasuk semua jaminan tersirat mengenai dapat diperjualbelikan, kesesuaian untuk tujuan tertentu, hak milik, dan non-pelanggaran, serta jaminan yang mungkin timbul dari kebiasaan transaksi, pelaksanaan, penggunaan, atau praktik perdagangan. Tanpa membatasi hal tersebut, Saat Teduh tidak memberikan jaminan atau pernyataan apa pun bahwa aplikasi akan memenuhi kebutuhan Anda, mencapai hasil yang diinginkan, kompatibel atau bekerja dengan perangkat lunak, sistem, atau layanan lain, beroperasi tanpa gangguan, memenuhi standar kinerja atau keandalan, bebas kesalahan, atau bahwa kesalahan/cacat apa pun dapat atau akan diperbaiki."
  },
  {
    "type": "paragraph",
    "text": "Tanpa membatasi ketentuan di atas, baik Saat Teduh maupun penyedia mana pun dari Saat Teduh tidak membuat pernyataan atau jaminan apa pun, tersurat maupun tersirat: (i) mengenai operasi atau ketersediaan aplikasi, atau informasi, konten, materi, maupun produk yang disertakan di dalamnya; (ii) bahwa aplikasi akan berjalan tanpa gangguan atau bebas kesalahan; (iii) mengenai akurasi, keandalan, atau kebaruan informasi maupun konten apa pun yang disediakan melalui aplikasi; atau (iv) bahwa aplikasi, servernya, kontennya, atau email yang dikirim dari atau atas nama Saat Teduh bebas dari virus, skrip, trojan horse, worm, malware, timebomb, atau komponen berbahaya lainnya."
  },
  {
    "type": "paragraph",
    "text": "Beberapa yurisdiksi tidak mengizinkan pengecualian atau pembatasan jaminan tersirat atau pembatasan hak hukum konsumen yang berlaku, sehingga sebagian atau seluruh pengecualian serta pembatasan di atas mungkin tidak berlaku bagi Anda."
  },
  {
    "type": "heading",
    "text": "Pembatasan Tanggung Jawab"
  },
  {
    "type": "paragraph",
    "text": "Terlepas dari kerugian apa pun yang mungkin Anda alami, seluruh tanggung jawab Saat Teduh dan pemasoknya berdasarkan ketentuan apa pun dalam Perjanjian ini serta upaya hukum eksklusif Anda untuk semua hal di atas akan dibatasi pada jumlah yang benar-benar Anda bayarkan untuk aplikasi."
  },
  {
    "type": "paragraph",
    "text": "Sejauh diizinkan oleh hukum yang berlaku, dalam keadaan apa pun Saat Teduh atau pemasoknya tidak bertanggung jawab atas kerugian khusus, insidental, tidak langsung, atau konsekuensial apa pun (termasuk namun tidak terbatas pada kerugian keuntungan, kehilangan data atau informasi lain, gangguan bisnis, cedera pribadi, kehilangan privasi yang timbul dari atau terkait dengan penggunaan atau ketidakmampuan menggunakan aplikasi, perangkat lunak pihak ketiga dan/atau perangkat keras pihak ketiga yang digunakan bersama aplikasi, atau hal lain terkait ketentuan Perjanjian ini), bahkan jika Saat Teduh atau pemasok mana pun telah diberitahu tentang kemungkinan kerugian tersebut dan bahkan jika upaya hukum gagal mencapai tujuan esensialnya."
  },
  {
    "type": "paragraph",
    "text": "Beberapa negara bagian/yurisdiksi tidak mengizinkan pengecualian atau pembatasan kerugian insidental atau konsekuensial, sehingga pembatasan atau pengecualian di atas mungkin tidak berlaku bagi Anda."
  },
  {
    "type": "heading",
    "text": "Keterpisahan"
  },
  {
    "type": "paragraph",
    "text": "Jika ada ketentuan dalam Perjanjian ini dinyatakan tidak dapat diberlakukan atau tidak sah, ketentuan tersebut akan diubah dan ditafsirkan untuk mencapai tujuan ketentuan tersebut sejauh mungkin berdasarkan hukum yang berlaku, dan ketentuan lainnya akan tetap berlaku penuh dan efektif."
  },
  {
    "type": "paragraph",
    "text": "Perjanjian ini, bersama Kebijakan Privasi dan pemberitahuan hukum lain yang dipublikasikan oleh Saat Teduh pada Layanan, merupakan keseluruhan perjanjian antara Anda dan Saat Teduh terkait Layanan. Jika suatu ketentuan dalam Perjanjian ini dianggap tidak sah oleh pengadilan yang berwenang, ketidakabsahan ketentuan tersebut tidak memengaruhi keabsahan ketentuan lain dalam Perjanjian ini, yang tetap berlaku penuh. Tidak ada pengesampingan atas ketentuan mana pun dalam Perjanjian ini yang dianggap sebagai pengesampingan lanjutan terhadap ketentuan tersebut atau ketentuan lain, dan kegagalan Saat Teduh untuk menegaskan hak atau ketentuan apa pun berdasarkan Perjanjian ini tidak merupakan pengesampingan atas hak atau ketentuan tersebut. ANDA DAN Saat Teduh SETUJU BAHWA SETIAP DASAR GUGATAN YANG TIMBUL DARI ATAU TERKAIT DENGAN LAYANAN HARUS DIAJUKAN DALAM SATU (1) TAHUN SETELAH DASAR GUGATAN TIMBUL. JIKA TIDAK, DASAR GUGATAN TERSEBUT GUGUR SECARA PERMANEN."
  },
  {
    "type": "heading",
    "text": "Pengesampingan"
  },
  {
    "type": "paragraph",
    "text": "Kecuali sebagaimana diatur di sini, kegagalan untuk menggunakan suatu hak atau menuntut pelaksanaan suatu kewajiban berdasarkan Perjanjian ini tidak memengaruhi kemampuan pihak untuk menggunakan hak tersebut atau menuntut pelaksanaan tersebut kapan pun setelahnya, juga pengesampingan atas suatu pelanggaran tidak merupakan pengesampingan atas pelanggaran berikutnya."
  },
  {
    "type": "paragraph",
    "text": "Tidak digunakannya, dan tidak adanya penundaan dalam penggunaan, oleh salah satu pihak atas hak atau kuasa apa pun berdasarkan Perjanjian ini tidak akan berlaku sebagai pengesampingan atas hak atau kuasa tersebut. Penggunaan tunggal atau sebagian dari hak atau kuasa apa pun berdasarkan Perjanjian ini juga tidak menghalangi penggunaan lebih lanjut atas hak tersebut atau hak lain yang diberikan di sini. Dalam hal terjadi pertentangan antara Perjanjian ini dan syarat pembelian atau syarat lain yang berlaku, ketentuan Perjanjian ini yang berlaku."
  },
  {
    "type": "heading",
    "text": "Perubahan terhadap Perjanjian ini"
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh berhak, atas kebijakannya sendiri, untuk memodifikasi atau mengganti Perjanjian ini kapan saja. Jika revisi bersifat material, kami akan memberikan pemberitahuan setidaknya 30 hari sebelum ketentuan baru berlaku. Apa yang dianggap perubahan material akan ditentukan atas kebijakan kami sendiri."
  },
  {
    "type": "paragraph",
    "text": "Dengan terus mengakses atau menggunakan aplikasi kami setelah revisi berlaku, Anda setuju untuk terikat oleh ketentuan yang direvisi. Jika Anda tidak setuju dengan ketentuan baru, Anda tidak lagi berwenang menggunakan Saat Teduh."
  },
  {
    "type": "heading",
    "text": "Keseluruhan Perjanjian"
  },
  {
    "type": "paragraph",
    "text": "Perjanjian ini merupakan keseluruhan perjanjian antara Anda dan Saat Teduh terkait penggunaan aplikasi oleh Anda dan menggantikan semua perjanjian tertulis atau lisan sebelumnya maupun pada saat yang sama antara Anda dan Saat Teduh."
  },
  {
    "type": "paragraph",
    "text": "Anda dapat tunduk pada syarat dan ketentuan tambahan yang berlaku ketika Anda menggunakan atau membeli layanan lain milik Saat Teduh, yang akan diberikan oleh Saat Teduh kepada Anda pada saat penggunaan atau pembelian tersebut."
  },
  {
    "type": "heading",
    "text": "Pembaruan terhadap Ketentuan Kami"
  },
  {
    "type": "paragraph",
    "text": "Kami dapat mengubah Layanan dan kebijakan kami, dan kami mungkin perlu melakukan perubahan pada Ketentuan ini agar secara akurat mencerminkan Layanan dan kebijakan kami. Kecuali diwajibkan lain oleh hukum, kami akan memberi tahu Anda (misalnya melalui Layanan kami) sebelum kami membuat perubahan pada Ketentuan ini dan memberi Anda kesempatan untuk meninjaunya sebelum berlaku. Kemudian, jika Anda terus menggunakan Layanan, Anda akan terikat oleh Ketentuan yang diperbarui. Jika Anda tidak ingin menyetujui ini atau Ketentuan yang diperbarui, Anda dapat menghapus akun Anda."
  },
  {
    "type": "heading",
    "text": "Kekayaan Intelektual"
  },
  {
    "type": "paragraph",
    "text": "Aplikasi beserta seluruh konten, fitur, dan fungsionalitasnya (termasuk namun tidak terbatas pada semua informasi, perangkat lunak, teks, tampilan, gambar, video, audio, serta desain, pemilihan, dan pengaturannya), dimiliki oleh Saat Teduh, pemberi lisensinya, atau penyedia materi tersebut lainnya dan dilindungi oleh hukum hak cipta, merek dagang, paten, rahasia dagang, serta hak kekayaan intelektual atau hak kepemilikan lainnya yang berlaku secara internasional. Materi tersebut tidak boleh disalin, dimodifikasi, direproduksi, diunduh, atau didistribusikan dengan cara apa pun, seluruhnya atau sebagian, tanpa izin tertulis terlebih dahulu secara tegas dari Saat Teduh, kecuali sebagaimana secara tegas diatur dalam Syarat & Ketentuan ini. Setiap penggunaan materi tanpa izin adalah dilarang."
  },
  {
    "type": "heading",
    "text": "Perjanjian untuk Arbitrase"
  },
  {
    "type": "paragraph",
    "text": "Bagian ini berlaku untuk setiap sengketa KECUALI TIDAK TERMASUK SENGKETA YANG BERKAITAN DENGAN KLAIM UNTUK UPAYA INJUNKTIF ATAU KEADILAN TERKAIT PENEGAKAN ATAU KEABSAHAN HAK KEKAYAAN INTELEKTUAL ANDA ATAU Saat Teduh. Istilah \"sengketa\" berarti setiap sengketa, tindakan, atau kontroversi lain antara Anda dan Saat Teduh terkait Layanan atau perjanjian ini, baik berdasarkan kontrak, jaminan, perbuatan melawan hukum, undang-undang, peraturan, ordonansi, atau dasar hukum/keadilan lainnya. \"Sengketa\" akan diberi makna seluas mungkin yang diizinkan oleh hukum."
  },
  {
    "type": "heading",
    "text": "Pemberitahuan Sengketa"
  },
  {
    "type": "paragraph",
    "text": "Dalam hal terjadi sengketa, Anda atau Saat Teduh harus memberikan Pemberitahuan Sengketa kepada pihak lainnya, yaitu pernyataan tertulis yang memuat nama, alamat, dan informasi kontak pihak yang memberikannya, fakta-fakta yang menimbulkan sengketa, serta pemulihan yang diminta. Anda harus mengirimkan Pemberitahuan Sengketa melalui email ke: [email protected] . Saat Teduh akan mengirimkan Pemberitahuan Sengketa kepada Anda melalui surat ke alamat Anda jika kami memilikinya, atau jika tidak ke alamat email Anda. Anda dan Saat Teduh akan berupaya menyelesaikan sengketa apa pun melalui negosiasi informal dalam waktu enam puluh (60) hari sejak tanggal Pemberitahuan Sengketa dikirim. Setelah enam puluh (60) hari, Anda atau Saat Teduh dapat memulai arbitrase."
  },
  {
    "type": "heading",
    "text": "Arbitrase yang Mengikat"
  },
  {
    "type": "paragraph",
    "text": "Jika Anda dan Saat Teduh tidak menyelesaikan sengketa melalui negosiasi informal, upaya penyelesaian sengketa lainnya akan dilakukan secara eksklusif melalui arbitrase yang mengikat sebagaimana dijelaskan pada bagian ini. Anda melepaskan hak untuk berperkara (atau berpartisipasi sebagai pihak atau anggota gugatan kelompok) atas seluruh sengketa di pengadilan di hadapan hakim atau juri. Sengketa akan diselesaikan melalui arbitrase yang mengikat sesuai aturan arbitrase komersial American Arbitration Association. Masing-masing pihak dapat meminta upaya injunktif sementara atau pendahuluan dari pengadilan yang berwenang, sebagaimana diperlukan untuk melindungi hak atau properti pihak tersebut selama proses arbitrase berlangsung. Seluruh biaya hukum, akuntansi, dan biaya lain yang timbul bagi pihak yang menang akan ditanggung oleh pihak yang kalah."
  },
  {
    "type": "heading",
    "text": "Pengajuan dan Privasi"
  },
  {
    "type": "paragraph",
    "text": "Apabila Anda mengirimkan atau memposting ide, saran kreatif, desain, foto, informasi, iklan, data, atau proposal apa pun, termasuk ide untuk produk, layanan, fitur, teknologi, atau promosi baru/lebih baik, Anda secara tegas setuju bahwa pengajuan tersebut secara otomatis diperlakukan sebagai tidak rahasia dan bukan kepemilikan, serta menjadi milik tunggal Saat Teduh tanpa kompensasi atau kredit apa pun kepada Anda. Saat Teduh dan afiliasinya tidak memiliki kewajiban apa pun sehubungan dengan pengajuan atau posting tersebut dan dapat menggunakan ide yang terkandung di dalamnya untuk tujuan apa pun dalam media apa pun untuk selamanya, termasuk namun tidak terbatas pada pengembangan, manufaktur, dan pemasaran produk maupun layanan menggunakan ide tersebut."
  },
  {
    "type": "heading",
    "text": "Promosi"
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh dapat, dari waktu ke waktu, menyelenggarakan kontes, promosi, undian, atau aktivitas lain (\"Promosi\") yang mengharuskan Anda mengirimkan materi atau informasi tentang diri Anda. Harap dicatat bahwa semua Promosi dapat diatur oleh aturan terpisah yang mungkin memuat persyaratan kelayakan tertentu, seperti batasan usia dan lokasi geografis. Anda bertanggung jawab membaca semua aturan Promosi untuk menentukan apakah Anda memenuhi syarat untuk berpartisipasi. Jika Anda mengikuti Promosi apa pun, Anda setuju untuk mematuhi seluruh Aturan Promosi."
  },
  {
    "type": "paragraph",
    "text": "Syarat dan ketentuan tambahan dapat berlaku untuk pembelian barang atau layanan pada atau melalui Layanan, yang syarat dan ketentuan tersebut menjadi bagian dari Perjanjian ini melalui referensi ini."
  },
  {
    "type": "heading",
    "text": "Kesalahan Tipografi"
  },
  {
    "type": "paragraph",
    "text": "Dalam hal produk dan/atau layanan tercantum dengan harga atau informasi yang tidak benar karena kesalahan tipografi, kami berhak menolak atau membatalkan pesanan apa pun yang ditempatkan untuk produk dan/atau layanan yang tercantum pada harga yang tidak benar tersebut. Kami berhak menolak atau membatalkan pesanan tersebut baik pesanan telah dikonfirmasi maupun kartu kredit Anda telah ditagih. Jika kartu kredit Anda telah ditagih untuk pembelian dan pesanan Anda dibatalkan, kami akan segera mengeluarkan kredit ke akun kartu kredit Anda atau akun pembayaran lain sebesar jumlah tagihan tersebut."
  },
  {
    "type": "heading",
    "text": "Lain-lain"
  },
  {
    "type": "paragraph",
    "text": "Jika karena alasan apa pun pengadilan berwenang menyatakan ketentuan atau bagian mana pun dari Syarat & Ketentuan ini tidak dapat diberlakukan, sisa Syarat & Ketentuan ini akan tetap berlaku penuh dan efektif. Setiap pengesampingan ketentuan mana pun dalam Syarat & Ketentuan ini hanya berlaku jika dibuat secara tertulis dan ditandatangani oleh perwakilan resmi Saat Teduh. Saat Teduh berhak atas upaya injunktif atau upaya keadilan lainnya (tanpa kewajiban menyerahkan jaminan) jika terjadi pelanggaran atau dugaan pelanggaran oleh Anda. Saat Teduh mengoperasikan dan mengendalikan Layanan Saat Teduh dari kantornya di . Layanan ini tidak ditujukan untuk distribusi atau penggunaan oleh orang atau entitas mana pun di yurisdiksi atau negara mana pun di mana distribusi atau penggunaan tersebut bertentangan dengan hukum atau peraturan. Oleh karena itu, orang yang memilih mengakses Layanan Saat Teduh dari lokasi lain melakukannya atas inisiatif sendiri dan sepenuhnya bertanggung jawab atas kepatuhan terhadap hukum lokal, jika dan sejauh hukum lokal berlaku. Syarat & Ketentuan ini (yang mencakup dan menginkorporasi Kebijakan Privasi Saat Teduh) berisi keseluruhan pemahaman, dan menggantikan semua pemahaman sebelumnya, antara Anda dan Saat Teduh terkait pokok bahasannya, dan tidak dapat diubah atau dimodifikasi oleh Anda. Judul bagian dalam Perjanjian ini hanya untuk kemudahan dan tidak memiliki dampak hukum."
  },
  {
    "type": "heading",
    "text": "Penafian"
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh tidak bertanggung jawab atas konten, kode, atau ketidaktepatan lainnya."
  },
  {
    "type": "paragraph",
    "text": "Saat Teduh tidak memberikan jaminan atau garansi."
  },
  {
    "type": "paragraph",
    "text": "Dalam keadaan apa pun Saat Teduh tidak bertanggung jawab atas kerugian khusus, langsung, tidak langsung, konsekuensial, atau insidental maupun kerugian apa pun, baik dalam tindakan kontrak, kelalaian, atau perbuatan melawan hukum lainnya, yang timbul dari atau terkait dengan penggunaan Layanan atau isi Layanan. Perusahaan berhak melakukan penambahan, penghapusan, atau modifikasi atas konten pada Layanan kapan saja tanpa pemberitahuan sebelumnya."
  },
  {
    "type": "paragraph",
    "text": "Layanan Saat Teduh dan kontennya disediakan \"as is\" dan \"as available\" tanpa jaminan atau pernyataan apa pun, baik tersurat maupun tersirat. Saat Teduh adalah distributor dan bukan penerbit konten yang disuplai pihak ketiga; dengan demikian, Saat Teduh tidak menjalankan kontrol editorial atas konten tersebut dan tidak memberikan jaminan atau pernyataan mengenai akurasi, keandalan, atau kebaruan informasi, konten, layanan, atau barang dagangan apa pun yang disediakan melalui atau dapat diakses lewat Layanan Saat Teduh. Tanpa membatasi hal tersebut, Saat Teduh secara khusus menolak semua jaminan dan pernyataan dalam konten apa pun yang ditransmisikan pada atau terkait dengan Layanan Saat Teduh atau pada situs yang mungkin muncul sebagai tautan pada Layanan Saat Teduh, atau pada produk yang disediakan sebagai bagian dari, atau terkait dengan, Layanan Saat Teduh, termasuk tanpa batasan jaminan dapat diperjualbelikan, kesesuaian untuk tujuan tertentu, atau non-pelanggaran hak pihak ketiga. Tidak ada nasihat lisan atau informasi tertulis yang diberikan oleh Saat Teduh atau afiliasi, karyawan, pejabat, direktur, agen, atau pihak sejenis lainnya yang akan menciptakan jaminan. Informasi harga dan ketersediaan dapat berubah tanpa pemberitahuan. Tanpa membatasi hal tersebut, Saat Teduh tidak menjamin bahwa Layanan Saat Teduh akan tanpa gangguan, tidak rusak, tepat waktu, atau bebas kesalahan."
  },
  {
    "type": "heading",
    "text": "Hubungi Kami"
  },
  {
    "type": "paragraph",
    "text": "Jangan ragu untuk menghubungi kami jika Anda memiliki pertanyaan."
  },
  {
    "type": "list",
    "items": [
      "Via Email: [email protected]"
    ]
  }
];

export default termsAndConditionsBlocksId;
